import { Stack, Typography } from '@mui/material'
import { COLORS } from 'app-constants'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { useNavigate } from 'react-router-dom'
import { TrendCompany } from 'api/model'

const CompanyItem = ({ company }: { company: TrendCompany }) => {
  const navigate = useNavigate()

  const onCompanyClick = () => {
    navigate(`/trends/company?name=${company.system_name}`)
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      onClick={onCompanyClick}
      p="20px"
      sx={{
        background: COLORS.PURE_WHITE,
        borderRadius: '16px',
        boxShadow: '2px 4px 20px 0px rgba(0, 0, 0, 0.02)',
        cursor: 'pointer',
      }}>
      <Typography variant="h5">{company.name}</Typography>

      <KeyboardArrowRightIcon />
    </Stack>
  )
}

export default CompanyItem
